import Commons from "oc-commons/Commons.js";

/**
 * AbstractRichMetadata reichert clientseitig die vom Backend gelesenen Metadata an.
 * Die Klasse sollte von der App abgeleitet und um projektspezifische Funktionalität ergänzt werden.
 *
 * UseCases zur Initialisierungzeit:
 *   - Datenstrukturen für schnelleren Zugriff aufbauen
 *   - Validierungen vornehmen
 *
 * UsesCases zur Laufzeit:
 *   - Facade für den einfachen Zugriff auf Metadata
 *
 * Generell werden die Objekte der Metadata transformiert, es können aber auch eigene Datenstrukturen aus
 * Metadata extrahiert und in RichMetadata gehalten werden.
 *
 * AbstractRichMetadata dient dazu, zum einen das Konzept als solches vorzugeben, und
 * den generalisierbaren Teil abzubilden.
 *
 * Auf die Instanz von RichMetadata kann über APP.richMetadata zugegriffen werden.
 */
export default class AbstractRichMetadata {

    constructor(metadata = APP.metadata) {
        this.metadata = metadata;
        if (this.metadata) {
            this.initPrimaryKeyFindMethods();
        }
    }

    ///////////////////////////////////////////////////////////////////
    // Zugriffsmethoden
    ///////////////////////////////////////////////////////////////////

    /***
     * kann zum Beispiel im abgeleiteten Konstruktor aufgerufen werden um für eine bestimmte Tabelle eine find Funktion zu generieren
     * @param tableName
     * @param keyColumn
     * @example
     *  this.initTableLookup('Model','Key'); // in Konstruktor der RichMetadata
     *   APP.richMetadata.findModel('modelkey'); // im Code
     * }
     */
    initTableLookup(tableName,...keyColumns){
        if (this['find'+tableName]) {
            return;
        }
        if (keyColumns.length==1) {
            const keyColumn = keyColumns[0];
            this['find'+tableName]=Commons.cacheIdentity((keyColumnValue)=>
                this.metadata[tableName].find(row=>row[keyColumn] == keyColumnValue));
        } else {
            this['find'+tableName]=Commons.cache((...keyColumnValues)=>
                this.metadata[tableName].find(row=>
                    keyColumns.every((c,i)=> {
                        return row[c] == keyColumnValues[i]
                    })));
        }
    }

    /**
     * erzeugt für alle Tabellen find-Methoden, die einen PrimaryKey  haben
     */
    initPrimaryKeyFindMethods() {
        APP.metamodel.tables.filter(table=>this.metadata[table.name]!=null).forEach(table=>{
            const primary = table.columns.find(c=>c.primaryKey);
            if (primary) {
                this.initTableLookup(table.name,primary.name);
            }
            if (!Commons.isEmpty(table.uniqueIndex)) {
                this.initTableLookup(table.name,...table.uniqueIndex.filter(s=>s!='App'));
            }
        });
    }

}
